import { FETCH_PRODUCTS_COUNT_REQUEST, FETCH_PRODUCTS_COUNT_SUCCESS, FETCH_PRODUCTS_COUNT_FAILURE, } from "../../actions";
const initialState = {
    fetchProductsCount: null,
    isLoading: false,
    error: null,
};
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_PRODUCTS_COUNT_REQUEST:
            return Object.assign(Object.assign({}, state), { isLoading: true, error: null });
        case FETCH_PRODUCTS_COUNT_SUCCESS:
            return Object.assign(Object.assign({}, state), { fetchProductsCount: action.payload, isLoading: false, error: null });
        case FETCH_PRODUCTS_COUNT_FAILURE:
            return Object.assign(Object.assign({}, state), { isLoading: false, error: action.payload });
        default:
            return state;
    }
};
export default reducer;
